import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { siteSettingsApi } from "./api";
import type { SiteSettingsForm } from "./types";

export const siteSettingsKeys = {
  detail: ["site-settings"] as const,
};

export function useSiteSettings() {
  return useQuery({ queryKey: siteSettingsKeys.detail, queryFn: siteSettingsApi.get });
}

export function useUpdateSiteSettings() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ input, includeMaintenanceMode }: { input: SiteSettingsForm; includeMaintenanceMode: boolean }) =>
      siteSettingsApi.update(input, includeMaintenanceMode),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: siteSettingsKeys.detail }),
  });
}
